import React, { useEffect } from 'react';

interface CalendlyInlineProps {
  url: string;
  minHeight?: string;
  className?: string;
  fillHeight?: boolean;
  showHeading?: boolean;
}

const CALENDLY_SCRIPT_SRC = 'https://assets.calendly.com/assets/external/widget.js';

const CalendlyInline: React.FC<CalendlyInlineProps> = ({ url, minHeight = '720px', className = '', fillHeight = false, showHeading = true }) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${CALENDLY_SCRIPT_SRC}"]`)) {
      return;
    }
    const script = document.createElement('script');
    script.src = CALENDLY_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const handleCalendly = (e: MessageEvent) => {
      if (e.origin !== 'https://calendly.com') return;
      const data = e.data;
      if (!data || typeof data !== 'object') return;

      if (data.event === 'calendly.event_scheduled') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'calendly_booked',
          calendly_event_name: data.payload?.event_type?.name || '',
        });
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', {
            method: 'calendly',
            calendly_event_name: data.payload?.event_type?.name || '',
          });
        }
      }
      if (data.event === 'calendly.date_and_time_selected') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'calendly_slot_selected' });
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'calendly_slot_selected');
        }
      }
    };
    window.addEventListener('message', handleCalendly);
    return () => window.removeEventListener('message', handleCalendly);
  }, []);

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden ${fillHeight ? 'flex flex-col h-full' : ''} ${className}`}>
      {showHeading && (
        <div className="px-6 pt-6 pb-2">
          <h3 className="font-bold text-2xl mb-1 text-gray-900">Plan uw strategiegesprek</h3>
          <p className="text-gray-600 text-sm">Kies een tijdstip dat u past — directe bevestiging in uw agenda.</p>
        </div>
      )}
      <div
        className={`calendly-inline-widget ${fillHeight ? 'flex-1' : ''}`}
        data-url={url}
        style={fillHeight ? { minWidth: '320px', minHeight } : { minWidth: '320px', height: minHeight }}
      />
      <noscript>
        <a href={url} target="_blank" rel="noopener noreferrer" className="block text-center text-brand-blue underline py-4">
          Open agenda in nieuw tabblad
        </a>
      </noscript>
    </div>
  );
};

export default CalendlyInline;